"use client";

import { motion } from "motion/react";

/**
 * Motion-powered animated gradient orbs for the auth page decorative panel.
 * Uses spring-based drift for organic "breathing" feel.
 * Respects prefers-reduced-motion via the global reduced-motion styles in globals.css.
 */
export function AnimatedBackground() {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
      {/* Large purple orb — top left */}
      <motion.div
        className="absolute -left-20 -top-20 h-[340px] w-[340px] rounded-full opacity-30 blur-3xl"
        style={{
          background:
            "radial-gradient(circle, var(--gradient-start) 0%, transparent 70%)",
        }}
        animate={{
          x: [0, 20, -10, 0],
          y: [0, -15, 8, 0],
          scale: [1, 1.05, 0.98, 1],
        }}
        transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
      />

      {/* Medium blue orb — bottom right */}
      <motion.div
        className="absolute -bottom-16 -right-16 h-[280px] w-[280px] rounded-full opacity-25 blur-3xl"
        style={{
          background:
            "radial-gradient(circle, var(--gradient-end) 0%, transparent 70%)",
        }}
        animate={{
          x: [0, -15, 8, 0],
          y: [0, 10, -12, 0],
          scale: [1, 0.97, 1.03, 1],
        }}
        transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
      />

      {/* Small indigo orb — center */}
      <motion.div
        className="absolute left-1/2 top-1/2 h-[180px] w-[180px] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-20 blur-3xl"
        style={{
          background:
            "radial-gradient(circle, var(--gradient-mid) 0%, transparent 70%)",
        }}
        animate={{
          x: [0, 12, -8, 0],
          y: [0, -10, 6, 0],
          scale: [1, 1.03, 0.96, 1],
        }}
        transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
      />

      {/* Decorative glass ring — top right */}
      <motion.div
        className="absolute right-12 top-24 h-24 w-24 rounded-full border border-[var(--glass-border)] opacity-40"
        style={{
          background: "var(--glass-1-bg)",
          backdropFilter: "blur(8px)",
        }}
        animate={{
          y: [0, -8, 4, 0],
          x: [0, 4, -2, 0],
        }}
        transition={{ duration: 9, repeat: Infinity, ease: "linear" }}
      />

      {/* Decorative glass ring — bottom left */}
      <motion.div
        className="absolute bottom-32 left-16 h-16 w-16 rounded-full border border-[var(--glass-border)] opacity-30"
        style={{
          background: "var(--glass-1-bg)",
          backdropFilter: "blur(8px)",
        }}
        animate={{
          y: [0, -6, 3, 0],
          rotate: [0, 2, -1, 0],
        }}
        transition={{ duration: 7, repeat: Infinity, ease: "linear" }}
      />
    </div>
  );
}
